import React, { useState } from "react";
import { Button, TextField } from "@material-ui/core";
import "./UpdatePassword.css";

let langData = require("../../../Data/language.json");

export default function UpdatePassword(props) {
  const [newPassword, setNewPassword] = useState("");

  return (
    <div
      className="container-fluid col-lg-4 col-md-10 col-sm-10"
      id="updatePassContainer"
    >
      <div className="inputWrapper">
        <TextField
          id="outlined-re-password-input"
          label={langData[props.language].profile.newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          type="password"
          autoComplete="current-password"
          margin="normal"
          variant="outlined"
        />
        <p className="errorText">{props.errorText}</p>
        <Button
          variant="outlined"
          onClick={() => props.updatePassword(newPassword)}
        >
          {langData[props.language].profile.updatePassword}
        </Button>
      </div>
    </div>
  );
}
